import { RouteRecordRaw } from 'vue-router';
import { route } from '@/router/utils'
// import { allPermissions } from '@access/index'
// import { accessPermission } from '@/permissions/permissions'

// const {
//   STAFF: {
//     USER: {
//       VIEW
//     },
//   },
// } = allPermissions

const AccessDenied = () => import('./AccessDenied.vue')

export const ACCESS_DENIED_PAGE_NAME = 'cabinet:access-denied'

// URLs

export const ACCESS_DENIED_PAGE_URL = ''

export function createRoutes(options): RouteRecordRaw[] {
  return [
    route(ACCESS_DENIED_PAGE_URL, AccessDenied, ACCESS_DENIED_PAGE_NAME, {
      meta: {
        breadcrumb: 'access-denied',
        // ...accessPermission([VIEW], options),
      }
    }),
  ]
}
